import { z } from 'zod';
import { SessionStatus, UserRole, SessionTimeouts } from '../constants/session.constants';

// Validación estricta de teléfono internacional o local (mínimo 10 dígitos)
export const PhoneNumberSchema = z
  .string()
  .trim()
  .min(10, 'El número telefónico debe tener al menos 10 dígitos')
  .max(16, 'El número telefónico no puede exceder 16 caracteres')
  .regex(/^\+?[1-9]\d{9,14}$/, 'Formato telefónico inválido (se requiere formato E.164 o local de 10 dígitos)');

export const CreateSessionRequestSchema = z.object({
  phoneNumber: PhoneNumberSchema,
  incidentFolio: z
    .string()
    .trim()
    .min(3, 'El folio debe tener al menos 3 caracteres')
    .max(50, 'El folio no puede exceder 50 caracteres'),
  dispatcherId: z
    .string()
    .trim()
    .min(1, 'El identificador del despachador es requerido')
    .max(64),
  dispatcherName: z
    .string()
    .trim()
    .min(2, 'El nombre del despachador es requerido')
    .max(100),
  notes: z.string().trim().max(1000).optional(),
  agencyId: z.string().trim().optional(),
  cadFolio: z.string().trim().max(50).optional(),
  expirationMinutes: z
    .number()
    .int()
    .min(1)
    .max(SessionTimeouts.MAX_TOKEN_EXPIRATION_MINUTES)
    .default(SessionTimeouts.DEFAULT_TOKEN_EXPIRATION_MINUTES)
});

export const JoinSessionRequestSchema = z.object({
  sessionId: z.string().uuid('ID de sesión con formato inválido'),
  token: z.string().min(10, 'Token de sesión requerido'),
  role: z.nativeEnum(UserRole)
});

export const EndSessionRequestSchema = z.object({
  sessionId: z.string().uuid('ID de sesión con formato inválido'),
  reason: z.string().trim().min(2).max(255),
  notes: z.string().trim().max(2000).optional()
});

export const SessionResponseSchema = z.object({
  sessionId: z.string().uuid(),
  incidentFolio: z.string(),
  phoneNumber: z.string(),
  citizenToken: z.string(),
  citizenAccessUrl: z.string().url(),
  spectatorToken: z.string(),
  spectatorAccessUrl: z.string().url(),
  status: z.nativeEnum(SessionStatus),
  createdAt: z.string().datetime(),
  expiresAt: z.string().datetime()
});

export type CreateSessionRequest = z.infer<typeof CreateSessionRequestSchema>;
export type JoinSessionRequest = z.infer<typeof JoinSessionRequestSchema>;
export type EndSessionRequest = z.infer<typeof EndSessionRequestSchema>;
export type SessionResponse = z.infer<typeof SessionResponseSchema>;
